// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse.attributeTypeMap;
    }
}
AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse.discriminator = undefined;
AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse.additionalProperties = false;
AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse.js.map